﻿import common = require("../../../common");
import core = require("../../../core");
import Vue from 'vue';
import Component from 'vue-class-component'
import HotEditableFormManager = require("./HotEditableFormManager");
import utilities = require("../../utilities");
import context = require("../../context");
import HotEditableHelpers = require("./HotEditableHelpers");
import HotEditableHiddenFieldComponent = require("./HotEditableHiddenFieldComponent");

declare function __getHotEditableCheckBoxComponentTemplate(): string;

enum HotEditableCheckboxDefaultTextualValues {
    true = 'oui',
    false = 'non'
};

/*
 * <input type="checkbox" checked  id="" class="" chx-label="" chx-show-label="" chx-group="" chx-use-group="" chx-group-behavior="" />
 * <hoteditablecheckbox init-checked="" init-id="" init-chx-label="" init-class="" init-chx-show-label="" init-chx-group="" init-chx-use-group="" init-chx-group-behavior="" init-disabled="true" ></hoteditablecheckbox>
 */
@Component((
    {
        props:
        {
            initId: String,
            initName: String,
            initChecked: String,
            initValue: Boolean,
            initTitle: String,
            initClass: String,
            initDisabled: Boolean,
            initTabIndex: Number,
            initDisplayName: String,
            initRequired: String,
            /** Includes HTML markup support */
            initLabel: String,
            initTextualTrue: String,
            initTextualFalse: String,
            initEditModeOn: Boolean,
            initCanChangeEditMode: Boolean,
            initHidden: Boolean,
            initGroup: String,
            initGroupBehavior: String,
            initOnPreChange: String,
            initRevertLastChangesOnConfirmationRejected: Boolean
            // initDefaultValue: Boolean
        }
    }))
class HotEditableCheckboxComponent extends Vue implements common.IHotEditableFieldComponent {
    initId: string;
    initName: string;
    initChecked: string;
    initValue: boolean;
    initTitle: string;
    initClass: string;
    initDisabled: string;
    initTabIndex: number;
    initDisplayName: string;
    initRequired: string;
    /** Includes HTML markup support */
    initLabel: string;
    initTextualTrue: string;
    initTextualFalse: string;
    initEditModeOn: boolean;
    initCanChangeEditMode: boolean;
    initHidden: boolean;
    initGroup: string;
    initGroupBehavior: string;
    initOnPreChange: string;
    initRevertLastChangesOnConfirmationRejected: boolean;
    // initDefaultValue: boolean;

    rootId: string;
    title: string;
    editModeOn: boolean;
    canChangeEditMode: boolean;
    elementValue: boolean;
    disabled: boolean;//elementDisabled
    /** Includes HTML markup support */
    label: string;
    textualTrue: string;
    textualFalse: string;
    tabIndex: number;
    displayName?: string;
    required: boolean;
    cssClass: string;
    elementName: string;
    idElement: string;
    group: string;
    groupBehavior: core.CheckboxBehaviorModes;
    onPreChange: string;
    revertLastChangesOnConfirmationRejected: boolean;
    hidden: boolean;
    hasError: boolean;
    fieldType = common.HotEditableFieldTypes.checkbox;

    _isIe = null;
    _previousValue = null as boolean;
    _formManagerParent: HotEditableFormManager;//NOTE: Doit undefined initialement car il est definie dans le "beforeCreate"
    //_disableNextChangedAction = false;//NOTE: Previens le double-changed en provenance du input::blur()

    static tagName = "hoteditablecheckbox";
    static prepareMarkup(element: HTMLElement) {

        if (!element)
            throw "[" + this.tagName + "::prepareMarkup] L'element est NULL";

        element.removeAttribute("hot-editable");
        element.setAttribute("hot-editable-cloak", "");

        const newOuterHtml = element.outerHTML.replace('<input ', '<' + this.tagName + ' ')
            .replace(' id=', ' init-id=')
            .replace(' name=', ' init-name=')
            .replace(' checked=', ' init-checked=')
            .replace(' checked ', ' init-checked="checked" ')//supporter attribute seulement
            .replace(' value=', ' v-bind:init-value=')
            .replace(' class=', ' init-class=')
            .replace(' disabled ', ' init-disabled=')
            .replace(' required=', ' init-required=')
            .replace(' title=', ' init-title=')
            .replace(' display-name=', ' init-display-name=')
            .replace(' label=', ' init-label=')
            .replace(' textual-true=', ' init-textual-true=')
            .replace(' textual-false=', ' init-textual-false=')
            .replace(' tabindex=', ' v-bind:init-tab-index=')
            .replace(' edit-mode-on=', ' v-bind:init-edit-mode-on=')
            .replace(' can-change-edit-mode=', ' v-bind:init-can-change-edit-mode=')
            .replace(' hidden=', ' v-bind:init-hidden=')
            .replace(' revert-last-changes-on-confirmation-rejected=', ' v-bind:init-revert-last-changes-on-confirmation-rejected=')
            //.replace(' default-value=', ' init-default-value=')
            .replace(' group=', ' init-group=')
            .replace(' group-behavior=', ' init-group-behavior=')
            .replace(' on-pre-change=', ' init-on-pre-change=');

        element.outerHTML = newOuterHtml;
    }
    static defaultValue() {
        return "false";
    }
    data() {
        const guid = utilities.createGuid('N');
        const id = this.initId || "Field_" + guid;
        const isChecked = this.initChecked === '' || this.initChecked === 'checked';

        const o = {
            rootId: "HotEditableField_" + guid,
            idElement: id,
            elementName: this.initName || id,
            elementValue: isChecked,
            // elementDisabled: this.initDisabled === 'disabled',
            disabled: this.initDisabled === 'disabled',
            label: this.initLabel || null,
            textualTrue: this.initTextualTrue || HotEditableCheckboxDefaultTextualValues.true,
            textualFalse: this.initTextualFalse || HotEditableCheckboxDefaultTextualValues.false,
            tabIndex: this.initTabIndex,
            required: this.initRequired === 'required',
            displayName: this.initDisplayName || null,
            title: this.initTitle || '',
            cssClass: this.initClass || '',
            hidden: this.initHidden === true,
            hasError: false,
            editModeOn: this.initEditModeOn === true,
            canChangeEditMode: this.initCanChangeEditMode === true,
            group: this.initGroup || '',
            groupBehavior: this.initGroupBehavior
                ? core.CheckboxBehaviorModes[this.initGroupBehavior] || (() => { throw "L'argument 'initGroupBehavior', dont la valeur vaut '" + this.initGroupBehavior + "', est invalide."; })()
                : core.CheckboxBehaviorModes.nothingOrMany,
            onPreChange: this.initOnPreChange || null,
            revertLastChangesOnConfirmationRejected: this.initRevertLastChangesOnConfirmationRejected == true
        };
        return o;
    }

    updatePreviousValue(value?: any) {
        this._previousValue = value || value === '' || value === 0 || value === false ? value : this.elementValue;
        return this;
    }

    changeMode(canChangeEditMode: boolean, editModeOn: boolean) {
        this.updatePreviousValue();
        this.canChangeEditMode = canChangeEditMode;
        this.editModeOn = editModeOn;
    }

    setFromTextualValue(textualValue?: string) {

        if (textualValue === "true") {
            //textualValue is TRUE
            if (!this.elementValue) {
                // CHANGEMENT
                this.updatePreviousValue();
                this.elementValue = true;
                this.updateCssClass();
            }
            return this;
        }

        //textualValue is FALSE
        if (this.elementValue) {
            // CHANGEMENT
            this.updatePreviousValue();
            this.elementValue = false;
            this.updateCssClass();
        }

        return this;
    }
    /** Settera 'hidden' si TRUE ou FALSE, et retournera en tout temps 'hidden'. */
    isHidden(value?: boolean) {
        if (value === true || value === false)
            this.hidden = value;
        return this.hidden === true;
    }
    getTextualValue() {
        return this.elementValue === true ? "true" : "false";
    }

    beforeCreate() {
        this.$options.template = __getHotEditableCheckBoxComponentTemplate();

        this._formManagerParent = ((this.$parent as any).formManager as HotEditableFormManager).registerField(this);
    }

    created() {


        if (this.initDisabled) {
            if (this.elementValue) {
                const c = ' disabled';
                if (this.cssClass.indexOf(c) < 0)
                    this.cssClass += c;
            }
        }

        const isChecked = this.initChecked === '' || this.initChecked === 'checked';

        // Ajout est sélected au départ.
        if (isChecked) {// && this.initEditModeOn
            const c = ' selected';
            if (this.cssClass.indexOf(c) < 0)
                this.cssClass += c;
        }
    }

    mounted() {
        HotEditableHelpers.validateFieldSettings(this);

        (this.$el as Element).removeAttribute("hot-editable-cloak");

        this._isIe = context.env.browser.isIe;


        this.updatePreviousValue();

        // permet de faire fonctionner les esc/tab/enter
        document.addEventListener("keydown", e => {
            if (!this.canChangeEditMode || !this.editModeOn)
                return;

            const isEnter = utilities.isEnterKeyCode(e);
            const isEscape = !isEnter && utilities.isEscapeKeyCode(e);
            const isTab = !isEnter && !isEscape && utilities.isTabKeyCode(e);

            if (isEnter || isEscape || isTab) {
                this.preventDefault(e);
                //e.stopImmediatePropagation();// IMPORTANT: Necessite de stopper tout les events (et pas que ceux du/des parent(s)) en raison du $nextTick dans le Changed.

                const isShifted = e.shiftKey;
                if (isShifted) {
                    if (isTab)
                        setTimeout(() => {
                            this.onShiftTabClick(e);
                        }, 1);
                } else {
                    if (isEscape)
                        this.onEscapeClick(e);
                    else if (isTab)
                        setTimeout(() => {
                            this.onTabClick(e);
                        }, 1);
                    else if (isEnter)
                        this.onEnterClick(e);
                }
            }
        });

        //permet de faire fonctionner le blur
        document.addEventListener("mousedown", e => {
            if (!this.canChangeEditMode || !this.editModeOn)
                return;

            if (utilities.isOutside(e.target as Element, this.$el))
                this.onBlur(e);
        });
    }

    private evalOnPreChange() {
        if (this.onPreChange)
            eval(this.onPreChange);
        return this;
    }
    onChanged(event: Event) {
        this.preventDefault(event);
        this.changed();
    }

    onCancel(event: Event) {
        this.preventDefault(event);
        this.cancel();
    }

    onClear(event: Event) {
        this.preventDefault(event);
        this.clear();
    }

    clear() {
        this.elementValue = false;
        this.updateCssClass();
        this.$nextTick(() => {
            this.changed();
        });
    }
    private preventDefault(e?: Event, bypassStopPropagation?: boolean) {
        if (!e)
            return;

        e.preventDefault();

        if (bypassStopPropagation !== true)
            e.stopPropagation();
    }
    private static isCheckbox(field: common.IHotEditableFieldComponent) {
        return field.fieldType === common.HotEditableFieldTypes.checkbox;
    }

    private getSameGroupCheckboxes() {
        if (!this.group)
            return [];

        const groups = [] as HotEditableCheckboxComponent[];
        this._formManagerParent.getFields().forEach(x => {
            if (HotEditableCheckboxComponent.isCheckbox(x))
                if ((x as HotEditableCheckboxComponent) !== this && (x as HotEditableCheckboxComponent).group === this.group)
                    groups.push(x as HotEditableCheckboxComponent);
        });

        return groups;
    }

    private uncheckOthers() {
        const others = this.getSameGroupCheckboxes();
        for (let i = 0; i < (others || []).length; i++)
            others[i].check(false, true, true);
    }

    isChecked() {
        return this.elementValue;
    }

    isDisabled(isDisabled: boolean) {
        if (this.disabled === isDisabled)
            return this;

        this.disabled = isDisabled !== false;

        return this;
    }

    toggleCheck(fireEvent?: boolean, bypassApplyBehavior?: boolean) {
        return this.check(!this.elementValue, fireEvent, bypassApplyBehavior);
    }

    check(checked?: boolean, fireEvent?: boolean, bypassApplyBehavior?: boolean) {
        checked = checked !== false;//default=TRUE
        fireEvent = fireEvent !== false;//default=TRUE
        bypassApplyBehavior = bypassApplyBehavior === true;//default=FALSE

        if (this.disabled || (!this.editModeOn && !this.canChangeEditMode))
            return this;

        if (!bypassApplyBehavior && !this.applyBehavior(checked))
            return this;

        this.elementValue = checked;

        this.updateCssClass();

        if (!fireEvent)
            return this;

        if (this.disabled)
            return this;

        this.changed();

        return this;
    }

    private updateCssClass() {
        if (this.elementValue) {
            if (this.cssClass.indexOf(' selected') < 0)
                this.cssClass += ' selected';
        } else {
            if (this.cssClass.indexOf(' selected') >= 0)
                this.cssClass = this.cssClass.replace(' selected', '');
        }
    }

    applyBehavior(wantCheck: boolean) {
        if (this.groupBehavior === core.CheckboxBehaviorModes.nothingOrMany)
            return true;//Default=continue;

        const others = this.getSameGroupCheckboxes();
        var totalOthersIsChecked = 0;
        for (let i = 0; i < (others || []).length; i++)
            if (others[i].isChecked())
                totalOthersIsChecked++;

        // Validations
        const onNotSupportedBehaviorMode = () => {
            throw "ERREUR : Le valeur '" + this.groupBehavior + "' de '_config.behavior.mode' de la checkbox n'est pas valide.";
        };
        if (wantCheck) {
            //check...
            if (this.groupBehavior === core.CheckboxBehaviorModes.oneOnly) this.uncheckOthers();
            else if (this.groupBehavior === core.CheckboxBehaviorModes.oneOrMany) { /* do nothing */ }
            //else if (this.groupBehavior === core.CheckboxBehaviorModes.nothingOrMany) throw "Impossible car valeur par defaut.";
            else if (this.groupBehavior === core.CheckboxBehaviorModes.nothingOrOne) this.uncheckOthers();
            else onNotSupportedBehaviorMode();
        } else {
            //uncheck...
            if (this.groupBehavior === core.CheckboxBehaviorModes.oneOnly) {
                if (!totalOthersIsChecked) return false; //stop checking
            } else if (this.groupBehavior === core.CheckboxBehaviorModes.oneOrMany) {
                if (!totalOthersIsChecked) return false;//stop checking
            } else if (this.groupBehavior === core.CheckboxBehaviorModes.nothingOrOne) { /* do nothing */ }
            //else if (this.groupBehavior === core.CheckboxBehaviorModes.nothingOrMany) throw "Impossible car valeur par defaut.";
            else onNotSupportedBehaviorMode();
        }
        return true;//continue
    }

    onClick(event: Event) {

        // if (this.elementDisabled || (!this.editModeOn && !this.canChangeEditMode)) {
        //     this.preventDefault(event);

        //     if (this._isIe)
        //         // Fix pour IE : le "return false" pour canceler le event n'est pas honnore dans IE.
        //         this.elementValue = this._previousValue;

        //     // Previent le click du Label lorsque le control est en readonly. 
        //     return false;
        // }

        // return true;

        // NOTE: DESACTIVATION EN TOUT TEMPS DES CLICKS SUR LES LABELS
        this.preventDefault(event);

        if (this._isIe)
            // Fix pour IE : le "return false" pour canceler le event n'est pas honnore dans IE.
            this.elementValue = this._previousValue;

        // Previent le click du Label lorsque le control est en readonly. 
        return false;
    }

    onChange(event: Event) {

        //this.changed();
    }

    changed() {
        if (this.canChangeEditMode)
            this.editModeOn = false;

        this.$nextTick(() => {
            this.evalOnPreChange();

            this.$nextTick(() => {
                if (this.canChangeEditMode) {
                    //this.editModeOn = false;
                    this._formManagerParent.editModeChanged(this);

                    // if (this.elementValue === this._previousValue)
                    //     return;
                }
                this._formManagerParent.fieldChanged(this);
            });
        });
    }

    editClick(event?: Event, forcedMode?: boolean) {
        if (!this.canChangeEditMode)
            return;

        this.updatePreviousValue();

        if (forcedMode === true || forcedMode === false) {
            this.editModeOn = forcedMode;
            this.focus();
            return;
        }
        // else {
        //     //toggle
        //     this.editModeOn = !this.editModeOn;
        // }

        // cas special: on change directement la valeur.
        this.toggleCheck();
    }

    onEnterClick(event?: KeyboardEvent) {
        if (this.canChangeEditMode)
            this.preventDefault(event);

        this.toggleCheck(true);
    }

    onEscapeClick(event?: KeyboardEvent) {
        if (this.canChangeEditMode)
            this.preventDefault(event);

        this.cancel();
    }

    onTabClick(event?: KeyboardEvent) {
        if (event && event.shiftKey) {
            this.onShiftTabClick(event);
            return;
        }

        this.focusNextComponent();

        if (this.canChangeEditMode)
            this.preventDefault(event);
    }

    onShiftTabClick(event?: KeyboardEvent) {
        this.focusNextComponent(true);

        if (this.canChangeEditMode)
            this.preventDefault(event);
    }

    onBlur(event?: Event) {
        this.blur();
    }

    cancel() {
        if (!this.canChangeEditMode)
            return;

        this.elementValue = this._previousValue;

        this.editModeOn = false;

        //NOTE: Le "blur()" va lancer le "changed()"
        //this.$root.$emit('hotEditableTextbox-editModeChanged', this);
    }

    blur() {
        this.changed();
        //setTimeout(() => { this.changed(true); }, 250);
    }

    revertLastChanges() {
        if (!this.canChangeEditMode && !this.editModeOn)
            return false;

        if ((this._previousValue === true || this._previousValue === false) && this.elementValue !== this._previousValue) {
            this.check(this._previousValue, false);
            return true;
        }

        return false;
    }

    focus() {

        this.$nextTick(() => {
            if (!this.editModeOn)
                return;
            this.getInputElement().focus();
        });
    }
    manageHiddenFieldCsv(hiddenFieldName: string, value: string, append?: boolean) {
        if (!hiddenFieldName) throw "L'argument 'hiddenFieldName' est NULL.";
        if (append !== true && append !== false)
            append = this.elementValue;
        const f = this._formManagerParent.getFieldByName(hiddenFieldName) as HotEditableHiddenFieldComponent;
        if (!f) return;
        HotEditableHelpers.manageHiddenFieldCsv(f, value, append);
        return this;
    }

    /** Permet de mettre a jour un champs frere. L'argument 'valueProcessor' permet de formatter la textualValue (null et undefined signifnient "ne pas mettre a jour"). */
    updateBrotherFromCurrentValue(brotherElementName: string, valueProcessor?: (currentValue: boolean, currentTextualValue: string) => string) {
        if (!brotherElementName)
            return;
        const brother = this._formManagerParent.getFieldByName(brotherElementName);
        if (!brother)
            return;
        const currentTextualValue = this.getTextualValue();
        var textualValue: string;
        if (valueProcessor) {
            textualValue = valueProcessor(this.elementValue, currentTextualValue);
            if (!textualValue && textualValue !== '')
                return;// no update 
        } else {
            textualValue = currentTextualValue;
        }
        brother.setFromTextualValue(textualValue);
        return this;
    }

    private focusNextComponent(getPrevious?: boolean) {
        getPrevious = getPrevious === true;

        if (!this.canChangeEditMode)
            return false;

        //this.changed();//NOTE: Corrige le bug du auto-save lors du tab est corrige (auparavant il y avait sauvegarde au tab vers le prochain champs).
        this.editClick(null, false);

        if (getPrevious)
            this._formManagerParent.focusPreviousComponentFromField(this);
        else
            this._formManagerParent.focusNextComponentFromField(this);
    }

    private getInputElement() {
        const s = "input[type='checkbox']";
        const e = this.$el.querySelector(s);
        if (!e)
            throw "L'element '" + s + "' est inexistant.";
        return e as HTMLInputElement;
    }
}

export = HotEditableCheckboxComponent;